import * as yup from 'yup';

export const taxCodeSchema = yup
  .string()
  .required('Bạn chưa nhập mã số thuế')
  .test('valid-tax-code-format', 'Độ dài mã số thuế không đúng quy định', (value) => {
    if (!value) return false;

    // Valid formats based on Go regex patterns:
    const validFormats = [
      /^[0-9]{10}$/,           // 10 numbers
      /^[0-9]{10}-[0-9]{3}$/,  // 10 numbers-3 numbers
      /^[0-9]{12}$/,           // 12 numbers
      /^[0-9]{10}888$/         // 10 numbers + 888
    ];

    return validFormats.some(pattern => pattern.test(value));
  });

export const orderInvoiceSchema = yup.object().shape({
  companyName: yup.string().required('Tên công ty/Nhà thuốc/Quầy thuốc không được để trống'),
  taxCode: taxCodeSchema,
  companyAddress: yup.string().required('Địa chỉ xuất hóa đơn không được trống'),
});
